<main class="main-not-found">
  <sdc-card class="not-found-card">
    <div class="not-found-body">
      <h1 class="article-title">
        No configuration found for the determined club.
      </h1>

      <sdc-button variant="primary" type="button" (onClick)="retry()">
        Try again
      </sdc-button>
    </div>
  </sdc-card>
</main>
